import { render, staticRenderFns } from "./FuncionariosForm.vue?vue&type=template&id=3f97e3b4&scoped=true&"
import script from "./FuncionariosForm.vue?vue&type=script&lang=js&"
export * from "./FuncionariosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f97e3b4",
  null
  
)

export default component.exports